module.exports = __webpack_public_path__ + "img/221121-bimistock---pk-1@1x.3c4fcde3.png";